var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container",attrs:{"id":"not-found","data-padding":"sm"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"sectiontitle-element--center"},[_c('router-link',{staticClass:"btn--big--round .bg_success",attrs:{"to":{ name: 'Home' }}},[_vm._v("Return Home")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }